import Dragger from "antd/es/upload/Dragger";
import { Field, Legend, Label } from "../tailwind/fieldset";
import { Input, InputGroup } from "../tailwind/input";
import { Textarea } from "../tailwind/textarea";
import { Text } from "../tailwind/text";
import { Divider } from "../tailwind/divider";
import { Select } from "../tailwind/select";
import { handleUpdateCardComponent } from "../handleUpdateCardComponent";
import { InboxOutlined } from "@ant-design/icons";
import { handleUploadFile } from "../../functions/handleUploadFile";
import { handleBeforeUploadFile } from "../../functions/handleBeforeUploadFile";

export const CarouselPanel = ({
  selectedNode,
  isUploading,
  setIsUploading,
  paramOptions,
  user,
  nodes,
  setNodes,
  setCards,
  setModifications,
  carouselCardIndex,
  setCarouselCardIndex,
  carouselComponentIndex,
  setCarouselComponentIndex,
  setFile,
  setIsPanelOpened,
  setIsConvertCompressDialogOpen,
  selectedNodeConvertCompress,
  setSelectedNodeConvertCompress,
}) => {
  return (
    <>
      <Field>
        <Legend>Carousel</Legend>
        {selectedNode.data.cards.map((card, cardIndex) => (
          <div key={`card-${cardIndex}`}>
            <Text className="text-base font-bold mt-2">{`Card n° ${
              cardIndex + 1
            }`}</Text>

            {card.components?.map((component, componentIndex) => {
              switch (component.type) {
                case "HEADER":
                  return (
                    <div key={`header-${cardIndex}-${componentIndex}`}>
                      <Field>
                        <Text className="text-sm mb-1">
                          {`Header ${
                            component.format === "IMAGE" ? "image" : "video"
                          }`}
                        </Text>

                        <Field>
                          <Input
                            className="mb-1"
                            name="header URL"
                            key={`header_URL_card_${componentIndex}`}
                            value={component.link}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              handleUpdateCardComponent(
                                selectedNode,
                                cardIndex,
                                componentIndex,
                                { link: newValue },
                                nodes,
                                setNodes,
                                setCards,
                              );
                              setModifications(true);
                            }}
                            placeholder="https://example.com/"
                            autoComplete="off"
                            maxLength={2000}
                          />

                          <Dragger
                            className="mb-1"
                            name="file"
                            key="file"
                            showUploadList={false}
                            maxCount={1}
                            accept={
                              component.format === "IMAGE"
                                ? "image/jpeg,image/png,application/pdf"
                                : "video/mp4"
                            }
                            disabled={isUploading}
                            multiple={false}
                            height={200}
                            beforeUpload={(file) => {
                              const isValid = handleBeforeUploadFile({
                                file: file,
                                setFile: setFile,
                                selectedHeader: component.format.toLowerCase(),
                                setIsPanelOpened: setIsPanelOpened,
                                setIsConvertCompressDialogOpen:
                                  setIsConvertCompressDialogOpen,
                                cardIndex: cardIndex,
                                componentIndex: componentIndex,
                                carouselCardIndex: carouselCardIndex,
                                setCarouselCardIndex: setCarouselCardIndex,
                                carouselComponentIndex: carouselComponentIndex,
                                setCarouselComponentIndex:
                                  setCarouselComponentIndex,
                                selectedNode: selectedNode,
                                selectedNodeConvertCompress:
                                  selectedNodeConvertCompress,
                                setSelectedNodeConvertCompress:
                                  setSelectedNodeConvertCompress,
                              });
                              return isValid;
                            }}
                            action={(file) =>
                              handleUploadFile({
                                file: file,
                                setIsUploading: setIsUploading,
                                user: user,
                                selectedNode: selectedNode,
                                nodes: nodes,
                                setNodes: setNodes,
                                setCards: setCards,
                                setModifications: setModifications,
                                carouselCardIndex: cardIndex,
                                carouselComponentIndex: componentIndex,
                                selectedHeader: component.format.toLowerCase(),
                              })
                            }
                            onDrop={(e) => {
                              console.log(
                                "Dropped files",
                                e.dataTransfer.files,
                              );
                            }}
                          >
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                              Click or drag-and-drop a file to import it
                            </p>
                            <p className="ant-upload-hint">
                              Please upload a .jpeg or .png file. It must be
                              less than 5MB.
                            </p>
                          </Dragger>
                        </Field>
                      </Field>
                    </div>
                  );

                case "BODY":
                  return (
                    <div key={`body-${cardIndex}-${componentIndex}`}>
                      <Text className="text-base mb-1 mt-2">Body</Text>
                      <Textarea
                        name="Message"
                        key={`message_body_cards_${cardIndex}`}
                        placeholder="Message body"
                        value={component.text}
                        disabled
                        resizable={false}
                        maxLength={160}
                        autoComplete="off"
                      />
                      {component.bodyParameters &&
                        component.bodyParameters.length > 0 &&
                        component.bodyParameters?.map((p, index) => (
                          <Field key={index + "field-body_params_cards"}>
                            <Divider
                              className="mt-5 mb-3"
                              key={index + "divider_cards"}
                            />
                            <Label key={index + "label_cards"}>{`Parameter ${
                              index + 1
                            }`}</Label>
                            <Select
                              className="mb-2"
                              key={index + "bodyParam_cards"}
                              placeholder="Select a parameter"
                              onChange={(e) => {
                                var newParams = component.bodyParameters
                                  ? component.bodyParameters.map((param) => ({
                                      ...param,
                                    }))
                                  : [];

                                // Modifier le paramètre sélectionné
                                newParams[index] = {
                                  type: "text",
                                  selected: e.target.value,
                                  default:
                                    component.bodyParameters?.[index].default ||
                                    "",
                                };

                                handleUpdateCardComponent(
                                  selectedNode,
                                  cardIndex,
                                  componentIndex,
                                  { bodyParameters: newParams },
                                  nodes,
                                  setNodes,
                                  setCards,
                                );
                                setModifications(true);
                              }}
                              value={component.bodyParameters?.[index].selected}
                            >
                              {paramOptions.map((option, index) => (
                                <option
                                  key={`${option.value}-${index}`}
                                  value={option.value}
                                >
                                  {option.label}
                                </option>
                              ))}
                            </Select>
                            <div className="flex justify-between items-center">
                              <Label key={index + "defaultLabel"}>
                                {"Default value"}
                              </Label>
                              <Input
                                className="max-w-[75%]"
                                type="text"
                                key={index + "defaultInput"}
                                placeholder="Value if parameter is empty"
                                autoComplete="off"
                                value={
                                  component.bodyParameters?.[index].default ||
                                  ""
                                }
                                onChange={(e) => {
                                  var newParams = component.bodyParameters
                                    ? component.bodyParameters.map((param) => ({
                                        ...param,
                                      }))
                                    : [];

                                  // Modifier le paramètre sélectionné
                                  newParams[index] = {
                                    type: "text",
                                    default: e.target.value,
                                    selected:
                                      component.bodyParameters?.[index]
                                        .selected || "",
                                  };

                                  handleUpdateCardComponent(
                                    selectedNode,
                                    cardIndex,
                                    componentIndex,
                                    {
                                      bodyParameters: newParams,
                                    },
                                    nodes,
                                    setNodes,
                                    setCards,
                                  );
                                  setModifications(true);
                                }}
                              />
                            </div>
                          </Field>
                        ))}
                    </div>
                  );

                case "BUTTONS": {
                  const buttons = component.buttons ?? [];
                  const hasTwoButtons = buttons.length === 2;
                  const sameType =
                    hasTwoButtons &&
                    buttons[0].type.toLowerCase() ===
                      buttons[1].type.toLowerCase();
                  return (
                    <div
                      key={`buttons-${cardIndex}-${componentIndex}`}
                      className="mt-3"
                    >
                      <Divider className="mt-5" />
                      <div className="">
                        {component.buttons?.map((button, buttonIndex) => {
                          const shouldShowText =
                            !hasTwoButtons ||
                            (hasTwoButtons && sameType && buttonIndex === 0) ||
                            (hasTwoButtons && !sameType);
                          return (
                            <div key={`btn-${cardIndex}-${buttonIndex}`}>
                              {!shouldShowText && <br />}
                              <Field>
                                {button.type === "URL" ||
                                button.type === "url" ? (
                                  <>
                                    {shouldShowText && (
                                      <Text className="text-base mb-1 mt-2">{`Link${
                                        sameType ? "s" : ""
                                      }`}</Text>
                                    )}
                                    <InputGroup>
                                      <Input
                                        name={`Button card ${buttonIndex + 1}`}
                                        key={`input-card-${buttonIndex}`}
                                        value={button.text}
                                        disabled
                                        showCharacterCount
                                      />
                                      <Input
                                        className="mt-1"
                                        name={`Button url ${buttonIndex + 1}`}
                                        key={`input-url-card-${buttonIndex}`}
                                        value={button.url}
                                        disabled
                                      />
                                    </InputGroup>
                                  </>
                                ) : (
                                  <>
                                    {shouldShowText && (
                                      <Text className="text-base mb-1 mt-2">{`Button${
                                        sameType ? "s" : ""
                                      }`}</Text>
                                    )}
                                    <InputGroup className="">
                                      <Input
                                        name={`Button card ${buttonIndex + 1}`}
                                        key={`input-card-${buttonIndex}`}
                                        value={button.text}
                                        disabled
                                        showCharacterCount
                                      />
                                    </InputGroup>
                                  </>
                                )}
                              </Field>
                            </div>
                          );
                        })}
                      </div>
                      <Divider className="mt-5" />
                      <Divider className="mt-1" />
                    </div>
                  );
                }

                default:
                  return null;
              }
            })}
          </div>
        ))}
      </Field>
    </>
  );
};
